import CardWithTitle from 'components/atoms/CardWithTitle'
import PageTable from 'pages/CustomerManagement/Inquiry/PageTable'
import React from 'react'

function InquiryPage() {
  return (
    <CardWithTitle>
      <PageTable />
    </CardWithTitle>
  )
}

export default InquiryPage
